export enum MocUserRole {
  GENETIC_COUNSELLOR = "GENETIC_COUNSELLOR",
  NUTRITIONIST = "NUTRITIONIST",
  PHYSIOTHERAPIST = "PHYSIOTHERAPIST",
  PSYCHOLOGIST = "PSYCHOLOGIST",
  CONSULTANT = "CONSULTANT",
  RMO = "RMO",
  NURSE = "NURSE",
  PATIENT = "PATIENT",
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  CENTER_ADMIN = "CENTER_ADMIN",
  FRONT_DESK = "FRONT_DESK",
  BILL_DESK = "BILL_DESK",
  INSURANCE = "INSURANCE",
  ACCOUNTANT = "ACCOUNTANT",
  OPERATIONS = "OPERATIONS",
  MANAGEMENT = "MANAGEMENT",
  QUALITY = "QUALITY",
  MARKETING = "MARKETING",
  PATIENT_COORDINATOR = "PATIENT_COORDINATOR",
  HOME_CARE_RMO = "HOME_CARE_RMO",
  HOME_CARE_NURSE = "HOME_CARE_NURSE",
  CLINICAL_RESEARCH = "CLINICAL_RESEARCH",
  MRD = "MRD",
  CEO = "CEO",
}

export enum MocAppointmentType {
  IPD = "IPD",
  OPD = "OPD",
}

export enum MocDEAD {
  Dead = "Deceased",
}

export enum ErrorCode {
  PHONE_NUMBER_ALREADY_EXISTS = "PHONE_NUMBER_ALREADY_EXISTS",
  DUPLICATE_PATIENT = "DUPLICATE_PATIENT"
}
